export enum Language {
  En = "en",
}

export enum Currency {
  USD = "USD",
}

export type FormatCurrentInputProps = {
  input: string;
  decimals?: boolean;
  currency?: Currency;
};

export type GetCurrencyProps = {
  currency?: Currency;
};
